<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="modal-header">

  <h3 class="modal-title font">Nuevo gestor</h3>

    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <form class="form-search py-3" [formGroup]="formGroup">

      <div class="row-fields">
        <div class="field field-100">

          <label for="gestor">Gestor<span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="gestor" id="gestor" placeholder="Gestor" multiple>
                <mat-option *ngFor="let pto of gestorArray" [value]="pto">
                  {{ pto.id + ' - ' + pto.razonSocial + ' - ' + pto.nima + ' - ' + pto.centro }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

  </div>
  <div class="modal-footer actions">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="guardar()"
        aria-label="Guardar">Guardar</button>
    </div>
  </div>
</div>
